import { UnifiedLiquidityEnum, type MarketDataCardConfig } from '@talos/kyoko';
import type { MarketSelectorItem } from '../MarketSelector/types';
import { useHydratedMarketDataCardConfig } from './useHydratedMarketDataCardConfig';
import { useInitializedMarketAccountsConfig } from './useInitializedMarketAccountsConfig';
import { useMarketDataCardMarketSelectorItems } from './useMarketDataCardMarketSelectorItems';

interface UseMarketDataCardPreparedConfigParams {
  config: MarketDataCardConfig;
  onSave: (config: MarketDataCardConfig) => void;
  onDelete: (config: MarketDataCardConfig) => void;
}

export interface MarketDataCardPreparedConfig {
  config: MarketDataCardConfig;
  marketSelectorItems: MarketSelectorItem[];
}

/**
 * Builds market selector inventory once per card and runs hydration + initialization against that shared list.
 */
export function useMarketDataCardPreparedConfig({
  config,
  onSave,
  onDelete,
}: UseMarketDataCardPreparedConfigParams): MarketDataCardPreparedConfig {
  const marketSelectorItems = useMarketDataCardMarketSelectorItems({
    symbol: config.symbol,
    includeUnifiedLiquidityMarkets: config.unifiedLiquidity === UnifiedLiquidityEnum.Enabled,
    queryMSSRecords: false,
  });

  const hydratedConfig = useHydratedMarketDataCardConfig(config, onSave, marketSelectorItems);
  const preparedConfig = useInitializedMarketAccountsConfig({
    config: hydratedConfig,
    onSave,
    onDelete,
    items: marketSelectorItems,
  });

  return { config: preparedConfig, marketSelectorItems };
}
